import styled from "@emotion/styled"
import { Container, Desktop, NewText } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"

const TitleBox = styled.div`
  margin-bottom: 32px;
`
function TitleContent({ data }: { data: any }) {
  const title = extractProperty(data, "title")
  return (
    <Container>
      <Desktop>
        <TitleBox>
          <NewText
            component={"h3"}
            desktopFontSize={32}
            desktopLineHeight={"36px"}
            color={sharedColors.black}
          >
            {title}
          </NewText>
        </TitleBox>
      </Desktop>
    </Container>
  )
}

export default TitleContent
